<template>
    <div class="externalLinkList">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            funcName="getOrdersList"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="orders"
            :loading="loading"
            :menuAuth="menuAuth"
            :inputPlaceholder="inputPlaceholder"
            :selected="selectList.length"
        ></search-tool>

        <div class="table" :style="{ height: height }">
            <el-table
                :data="tableData"
                highlight-current-row
                height="100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" align="center">
                </el-table-column>
                <el-table-column
                    label="Name"
                    align="left"
                    property="name"
                >
                </el-table-column>
                <el-table-column
                    label="Link"
                    property="link"
                    align="left"
                >
                    <template slot-scope="scope">
                        <i class="el-icon-paperclip" style="font-size:14px;cursor:pointer" @click="links(scope.row.link)"></i>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Password"
                    property="password"
                    align="left"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.password}} </span> 
                        <i class="el-icon-document-copy" @click="copy(scope.row,'password')"></i>
                    </template>
                </el-table-column>
                <el-table-column
                    label="User"
                    property="email"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="Created_at"
                    property="created_at"
                    align="left"
                >
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg">
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <add :addVisible.sync="addVisible"></add>
        <edit :editVisible.sync="editVisible" :tableItem="tableItem"></edit>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Name、Password",
            searchForm: {
                name: "",
                user:"",
            },
            searchForm_transfer:{
                user:"",
            },
            selectList:[],
            funcName: "externalLink",
            advanceSearchFields: {
                user: {
                    label: "User",
                    type: "input",
                },
            },
        };
    },
    components: {
        
    },
    methods: {
        externalLink(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .externalLinkList(
                    {
                        ...this.searchForm,
                        ...this.paginationData,
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        //this.menuAuth = res.ext.op_auth;
                        this.paginationData.total = res.total;
                        this.closeDrawer();
                        this.loading = false;
                    }
                }).catch((err) => {
                    console.log('err: ', err);
                });
        },
        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        links(url){
             window.open(url, "_blank");
        },
    },
    created() {
        this.externalLink();
    },
    computed: {
        searchList() {
            return [
                {
                    label: this.$i18n.locale == "zh" ? "关键字" : "Keyword",
                    key: "keyword",
                    type: "input",
                },
                {
                    label: "User",
                    key: "user",
                    type: "input"
                },
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v && k !== 'status') {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.externalLinkList {
    height: 100%;
    background: #fff;
    width: 100%;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;
    }
}
</style>
